
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const ensureComponentColumns = async () => {
  try {
    
    // Abordagem alternativa: tente uma seleção simples para verificar se as colunas existem
    const { error } = await supabase
      .from('components')
      .select('repo_type, repo_name')
      .limit(1);
    
    if (error && error.message?.includes('does not exist')) {
      await addMissingColumnsDirectly();
    } else {
    }
  } catch (error) {
    await addMissingColumnsDirectly();
  }
};

const addMissingColumnsDirectly = async () => {
  try {
    // Tentamos executar dois comandos SQL separadamente para adicionar cada coluna
    // Como há um problema com o tipo da função rpc, usamos uma abordagem alternativa
    try {
      // @ts-ignore - Ignoramos o erro de tipo para executar a consulta
      await supabase.rpc('execute_sql', { 
        sql_query: 'ALTER TABLE components ADD COLUMN IF NOT EXISTS repo_type VARCHAR(50)' 
      });
    } catch (e) {
    }
    
    try {
      // @ts-ignore - Ignoramos o erro de tipo para executar a consulta
      await supabase.rpc('execute_sql', { 
        sql_query: 'ALTER TABLE components ADD COLUMN IF NOT EXISTS repo_name VARCHAR(255)' 
      });
    } catch (e) {
    }
    
  } catch (error) {
  }
};
